import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds.approval.title',
        defaultMessage: 'In-wallet approval',
    },
    gotIt: {
        id: 'modal.3ds.approval.got_it',
        defaultMessage: 'Got it',
    },
    description: {
        id: 'modal.3ds.approval.description',
        defaultMessage:
            "When you have something to approve, you'll see it in your wallet — open it on web or in the app, and tap Approve.",
    },
})
